var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsSwitchAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 13.3333L4.39992 12.3833L6.11658 10.6667H1.33325V9.33334H6.11658L4.39992 7.61667L5.33325 6.66667L8.66658 10L5.33325 13.3333ZM10.6666 9.33334L7.33325 6.00001L10.6666 2.66667L11.5999 3.61667L9.88325 5.33334H14.6666V6.66667H9.88325L11.5999 8.38334L10.6666 9.33334Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSwitchAccount);
export default __webpack_public_path__ + "static/media/icons-switch-account.1fae03bf.svg";
export { ForwardRef as ReactComponent };